module.exports = __webpack_public_path__ + "static/img/icon-c-carrer.22f286f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-c-carrer.png
// module id = GA61
// module chunks = 21